import {
  IAllocationClientValues,
  IClientAllocationDetailed,
} from '~/services/api/clientAllocation/types';

export const getAllocationIdByUserId = (
  id: number,
  clientAllocations: IClientAllocationDetailed[],
): IClientAllocationDetailed | undefined =>
  clientAllocations?.find(allocation => allocation.user.id === id && !allocation.isArchived);

export const getClientsFormFieldName = (teamMemberId: number, allocationId?: number): string =>
  `_${teamMemberId}${allocationId ? `_${allocationId}` : ''}`;

export const getClientMemberFormFieldName = (
  prefix: string,
  clientId: number,
  fieldNameMemberId: string,
): string => `${prefix}${clientId}${fieldNameMemberId}`;

export const getPayloadClients = (
  clients: number[],
  values: Record<string, unknown>,
  teamMemberId: number,
  clientAllocationId?: number,
): IAllocationClientValues[] =>
  clients.map(clientId => ({
    id: clientId,
    teamId:
      Number(
        values[
          getClientMemberFormFieldName(
            'teamId_',
            clientId,
            getClientsFormFieldName(teamMemberId, clientAllocationId),
          )
        ],
      ) || undefined,
    memo: values[
      getClientMemberFormFieldName(
        'memo_',
        clientId,
        getClientsFormFieldName(teamMemberId, clientAllocationId),
      ) || null
    ] as string,
  }));
